import {get} from 'lodash';

export default (state = {}, {coachId, rankId, targetName}: any) => {
  return {
    ...state,
    rankProgressionDetailVisibilities: {
      ...get(state, 'rankProgressionDetailVisibilities', {}),
      [`${coachId}->${rankId}.${targetName}`]: true,
    },
  };
};
